module.exports = __webpack_public_path__ + "img/dingdan_img1@3x.5f900618.png";